/**
 * screens/SyncLog/emptyState.ts
 * Copy for the sync log — empty, and gated on both connectors.
 */
import type { FlowNode, Step } from '../../components/EmptyState';

export const SYNC_FLOW: readonly FlowNode[] = [
  { key: 'record', label: 'Record', sub: 'in this subledger' },
  { key: 'count', label: 'Count', sub: 'prove the balance' },
  { key: 'route', label: 'Route', sub: 'name the consequence' },
  { key: 'land', label: 'Land', sub: 'Payroll or Billing', here: true },
];

export const SYNC_STEPS: readonly Step[] = [
  {
    n: '1',
    label: 'A consequence is raised',
    hint: 'A routed variance, a settled assignment, a transferred custody.',
  },
  {
    n: '2',
    label: 'It is delivered once',
    hint: 'Each event carries its own identity, so a retry cannot double-post.',
  },
  {
    n: '3',
    label: 'The destination returns a reference',
    hint: 'No reference means it has not landed, whatever the status says.',
  },
];

export const SYNC_COPY = {
  eyebrow: 'Sync log',
  title: 'Nothing has left this subledger yet',
  blurb:
    'Every consequence that leaves for Payroll or Billing appears here with the reference the destination returned.',
  flowNote:
    'This subledger is never the money of record. What it produces is a queue of consequences for the systems that are.',
  gateNote: 'Without both connectors there is nowhere for a consequence to go.',
  footNote: 'Events appear here as soon as something is routed.',
} as const;
